import React from "react"
import {Link} from "gatsby"
import styled from "styled-components"
import {Container, ButtonLink} from "./DesignSystem"
const StyledFooter = styled.footer`
    background: var(--lightGray);
    padding: var(--stackSpacingXL) 0;
    main {
      max-width: var(--contentMaxWidth);
      margin: 0 auto;
    }
    nav {
      margin-top: var(--stackSpacingM);
    }
    h2 {
      margin-bottom: 2rem;
    }
`
const ProjectItemWrapper = styled.div`
  margin-top: 1rem;
  a {
    display: flex;
    padding: 1rem;
    border-radius: 1rem;
    background: rgba(255, 255, 255, 0.6);
    border-top: 1px solid rgba(255, 255, 255, 0.4);
    align-items: center;
    transition: all 0.2s ease-in;
    &:hover {
      background: rgba(255, 255, 255, 0.9);
    }
  }
  
  img {
    margin-right: 2rem;
    width: 6rem;
    display: block;
    height: 6rem;
  }
  h3 {
    font-size: 1.4rem;
    margin-top: -3px; /* make it more balance */
  }
  h4 {
    font-weight: var(--normal);
    font-size: 1rem;
    margin-top: 0.5rem;
  }
`
const ProjectItem = props => {
  return (
    <ProjectItemWrapper>
    <Link to={props.slug}><img src={props.logo.publicURL} alt={props.title} /><br />
    <div>
    <h3>{props.tagline}</h3>
    <h4>{props.title} - {props.date}</h4>
    </div></Link>
    </ProjectItemWrapper>
  )
}

export const ProjectFooter = ({previous, next, others}) => {
    return (
    <StyledFooter>
    <Container>
    <main>
        <h2>Other case studies</h2>
        
        {others.map((project, i) => {
          return (
           
            <ProjectItem {...project.node.frontmatter} key={i} slug={project.node.fields.slug}></ProjectItem>
           
          )
        })}

        <nav>
          <ButtonLink to="/">← Back to homepage</ButtonLink>
        </nav>
       
        {/* <ul>
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul> */}
        </main>
    </Container>
    </StyledFooter> 
    );
}
export default ProjectFooter